export enum HeaderType {
  AUTHENTICATED_HEADER = 'AUTHENTICATED_HEADER',
  UNAUTHENTICATED_HEADER = 'UNAUTHENTICATED_HEADER',
}
